import React from 'react';
import AppModal from "@app/react/components/AppModal/AppModal.jsx";

export default function CartRemoveItemConfirmationModal({show, onConfirm, onCancel}) {
  return (
    <AppModal show={show} onHide={onCancel} title={Drupal.tt('elimina')}>
      <p>{Drupal.tt('vuoi eliminare l’articolo selezionato dal carrello?')}</p>
      <div className="d-flex justify-content-end mt-4">
        <button className="btn btn-danger" onClick={onConfirm}>{Drupal.tt('conferma')}</button>
      </div>
    </AppModal>
  );
}
